import { httpDelete, httpGet, httpPost, httpPut } from "@/src/api/http";
import type { DeleteRes, GetRes, PostRes, PutRes, Req } from "@/src/api/types";

export function listWorkspaces() {
    return httpGet<GetRes<"workspaces/">>(`workspaces/`);
}

export function createWorkspace(body: Req<"workspaces/", "post">) {
    return httpPost<PostRes<"workspaces/">>(`workspaces/`, body);
}

export function updateWorkspace(workspaceId: number, body: Req<"workspaces/{workspace_id}/", "put">) {
    return httpPut<PutRes<"workspaces/{workspace_id}/">>(`workspaces/${workspaceId}/`, body);
}

export function deleteWorkspace(workspaceId: number) {
    return httpDelete<DeleteRes<"workspaces/{workspace_id}/">>(`workspaces/${workspaceId}/`);
}

export function getWorkspacePermissions(workspaceId: number) {
    return httpGet<GetRes<"workspaces/{workspace_id}/permissions/">>(
        `workspaces/${workspaceId}/permissions/`,
    );
}

export function getWorkspaceUserPermissions(workspaceId: number) {
    return httpGet<GetRes<"workspaces/{workspace_id}/permissions/user/">>(
        `workspaces/${workspaceId}/permissions/user/`,
    );
}

export function updateWorkspacePermissions(
    workspaceId: number,
    mutations: Req<"workspaces/{workspace_id}/permissions/", "post">,
) {
    return httpPost<void>(`workspaces/${workspaceId}/permissions/`, mutations);
}

export function search(query: string) {
    return httpGet<GetRes<"search/">>(`search/?query=${encodeURIComponent(query)}`);
}

// --- training instance -----------------------------------------------------------------------

export function listMissingTrainingProcesses() {
    return httpGet<GetRes<"workspaces/missing_training_processes/">>(
        `workspaces/missing_training_processes/`,
    );
}

export function createUsersTrainingFolder(workspaceId: number, emailList: string[]) {
    return httpPost<void>(`workspaces/${workspaceId}/create_users_training_folder/`, { emailList });
}

export function getTrainingResults(workspaceId: number) {
    return httpGet<GetRes<"workspaces/{workspace_id}/training_results/">>(
        `workspaces/${workspaceId}/training_results/`,
    );
}

export function startTrainingFolder(workspaceId: number) {
    return httpPost<PostRes<"workspaces/{workspace_id}/start_training_folder/">>(
        `workspaces/${workspaceId}/start_training_folder/`,
        {},
    );
}
